import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import R from 'ramda';
import Picture from '@cotyorg/ccx-atoms/Picture';
import { getSubTotalPrice } from '../modules/selectors';
import ShoppingBagQuantitySelector from './ShoppingBagQuantitySelector';
import { analyticsDecorator } from '../utils';

const isDeleting = ({ removeState, product }) =>
  removeState && removeState.removing && product.ean === removeState.ean;

const generateRowClassNames = ({ deleting }) =>
  classNames('shopping-bag__row', {
    'is-deleting': deleting,
  });

const ShoppingBagRow = ({
  product,
  removeState,
  removeFromBasket,
  updateBasketItemQuantity,
  priceLabel,
  removeIconTitle,
  removeMessage,
}) => (
  <tr
    className={generateRowClassNames({
      deleting: isDeleting({ removeState, product }),
    })}
  >
    <td className="shopping-bag__cell shopping-bag__cell--image">
      {isDeleting({ removeState, product }) && (
        <strong className="message-overlay">{removeMessage}</strong>
      )}
      <div className="shopping-bag__cell__wrapper">
        <Picture alt={R.prop('name', product)} src={R.prop('image', product)} />
      </div>
    </td>

    <td className="shopping-bag__cell shopping-bag__cell--info">
      <div className="shopping-bag__cell__wrapper">
        <h3 className="product__title uppercase">{R.prop('name', product)}</h3>
        <p className="product__shade">{R.prop('shadeName', product)}</p>

        <button
          type="button"
          title={removeIconTitle}
          className="button--remove hide-for-medium"
          data-ean={R.prop('ean', product)}
          onClick={() => removeFromBasket(R.prop('ean', product))}
          // ! TODO Validate if this is still needed
          {...analyticsDecorator('delete-product', 'click')}
        >
          &times;
        </button>

        <p className="hide-for-medium">
          {priceLabel}{' '}
          <span className="value">{getSubTotalPrice(product)}</span>
        </p>

        <ShoppingBagQuantitySelector
          product={product}
          updateBasketItemQuantity={updateBasketItemQuantity}
        />
      </div>
    </td>

    <td
      className="
      shopping-bag__cell
      hide-for-xsmall-only
      hide-for-small-only"
    >
      <div className="shopping-bag__cell__wrapper">
        {priceLabel} <span className="value">{getSubTotalPrice(product)}</span>
      </div>
    </td>

    <td
      className="
      shopping-bag__cell
      hide-for-xsmall-only
      hide-for-small-only"
    >
      <div className="shopping-bag__cell__wrapper">
        <button
          type="button"
          title={removeIconTitle}
          className="button--remove"
          data-ean={R.prop('ean', product)}
          onClick={() => removeFromBasket(R.prop('ean', product))}
          // ! TODO Validate if this is still needed
          {...analyticsDecorator('delete-product', 'click')}
        >
          &times;
        </button>
      </div>
    </td>
  </tr>
);

ShoppingBagRow.propTypes = {
  product: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object])
  ),
  removeState: PropTypes.func,
  removeFromBasket: PropTypes.func,
  updateBasketItemQuantity: PropTypes.func,
  priceLabel: PropTypes.string,
  removeIconTitle: PropTypes.string,
  removeMessage: PropTypes.string,
};

export default ShoppingBagRow;
